export default __webpack_public_path__ + "static/media/phone.84374c92.svg";